import { Spinner, Stack } from '@chakra-ui/react';

import { useParams } from 'react-router-dom';
import { useGetRegistration } from '../../../../services/hooks/Registration/useGetRegistration';
import { useGetResultByStep } from '../../../../services/hooks/CandidateArea/useGetResultByStep';
import ResultPage from './mobile/result';

const SecondResult: React.FC = () => {
  // const { isMobile } = useContext(ContextAuth);
  const { registrationId } = useParams<{ registrationId: string }>();
  const getRegistration = useGetRegistration(registrationId || '');
  const getResult = useGetResultByStep(registrationId || '');

  const isLoading = getResult.isLoading || getRegistration.isLoading;

  // const isComplexData = (data: any): data is { score: any[]; classification: any[] } => {
  //   return data && typeof data === 'object' && 'score' in data && 'classification' in data;
  // };

  if (isLoading)
    return (
      <Stack>
        <Spinner />
      </Stack>
    );

  return <ResultPage registration={getRegistration.data} result={getResult.data} />;

  // return (
  //   <MainCard title="PROCESSO SELETIVO - " subtitle="RESULTADOS">
  //     {(isLoading && (
  //       <Stack>
  //         <Spinner />
  //       </Stack>
  //     )) || (
  //       <Stack mx={[5, 5, 5, 20, 20, 20]}>
  //         <Flex
  //           justify={['flex-start', 'flex-start', 'flex-start', 'space-between', 'space-between']}
  //           flexDir={['column-reverse', 'column-reverse', 'column-reverse', 'row', 'row']}
  //         >
  //           <Stack w={'100%'}>
  //             <TextM textAlign="center" fontWeight="bold" textTransform="uppercase">
  //               Dados do candidato
  //             </TextM>
  //             <Flex gap={2} flexDir={['column', 'column', 'row', 'row', 'row']}>
  //               <TextXS>
  //                 <strong>Nome: </strong>
  //                 {getRegistration.data?.candidate?.user?.full_name || '--'}
  //               </TextXS>
  //               {getRegistration.data?.candidate?.social_name && (
  //                 <TextXS>
  //                   <strong>Nome social: </strong>
  //                   {getRegistration.data?.candidate?.social_name || '--'}
  //                 </TextXS>
  //               )}
  //               <TextXS>
  //                 <strong>CPF: </strong>
  //                 {getRegistration.data?.candidate?.cpf || '--'}
  //               </TextXS>

  //               <TextXS>
  //                 <strong>Inscrição:</strong> {getRegistration.data?.registration_code || '--'}
  //               </TextXS>
  //             </Flex>

  //             <TextXS>
  //               <strong>Processo seletivo: </strong>
  //               {getRegistration.data?.selective_process_vacancy?.selective_process?.name || '--'}
  //             </TextXS>
  //             <TextXS>
  //               <strong>
  //                 {getRegistration.data?.selective_process_vacancy?.cultural_house
  //                   ? getRegistration.data?.selective_process_vacancy.class_level
  //                     ? 'Turma: '
  //                     : 'Turma - Primeira opção: '
  //                   : 'Vaga: '}
  //               </strong>
  //               {getRegistration.data?.selective_process_vacancy?.name || '--'}
  //               <TextXS>{getRegistration.data?.selective_process_vacancy?.details || ''}</TextXS>
  //             </TextXS>
  //             {getRegistration.data?.second_vacancy?.name && (
  //               <TextXS>
  //                 <strong>Turma - Segunda opção: </strong>
  //                 {getRegistration.data?.second_vacancy?.name || '--'}
  //                 <TextXS>{getRegistration.data?.second_vacancy?.details || ''}</TextXS>
  //               </TextXS>
  //             )}
  //           </Stack>
  //         </Flex>

  //         {getResult?.data?.final && (
  //           <>
  //             <Divider pt={3} mb={3} borderColor="secondaryColor" />
  //             <Stack>
  //               <TextM textAlign="center" fontWeight="bold" textTransform="uppercase">
  //                 RESULTADO FINAL
  //               </TextM>
  //               <Box borderWidth="1px" borderRadius="xl" p={5} shadow="md">
  //                 <>
  //                   <VStack align="start" spacing={1}>
  //                     {/* <TextXS>
  //                       <strong>Tipo de resultado:</strong> {getResult?.data?.final?.name}
  //                     </TextXS> */}

  //                     {isComplexData(getResult?.data?.final?.data) && (
  //                       <>
  //                         {getResult.data.final.data.classification.map((classItem, idx) => {
  //                           const label = classItem.label.toLowerCase();

  //                           if (label.includes('ampla concorrência')) {
  //                             return (
  //                               <ResultStepCard
  //                                 key={idx}
  //                                 title="Classificação ampla concorrência"
  //                                 position={classItem.position}
  //                                 status={classItem.status}
  //                               />
  //                             );
  //                           }

  //                           if (
  //                             label.includes('geral') &&
  //                             (getRegistration?.data?.type_of_competition?.length ?? 0) > 1
  //                           ) {
  //                             return (
  //                               <ResultStepCard
  //                                 key={idx}
  //                                 title="Classificação geral"
  //                                 position={classItem.position}
  //                                 status={classItem.status}
  //                               />
  //                             );
  //                           }

  //                           if (label.includes('pcd')) {
  //                             return (
  //                               <ResultStepCard
  //                                 key={idx}
  //                                 title="Classificação PCD"
  //                                 position={classItem.position}
  //                                 status={classItem.status}
  //                               />
  //                             );
  //                           }

  //                           if (label.includes('preto') || label.includes('pardo')) {
  //                             return (
  //                               <ResultStepCard
  //                                 key={idx}
  //                                 title="Classificação pretos e pardos"
  //                                 position={classItem.position}
  //                                 status={classItem.status}
  //                               />
  //                             );
  //                           }

  //                           if (label.includes('segunda') || label.includes('2')) {
  //                             return (
  //                               <ResultStepCard
  //                                 key={idx}
  //                                 title="Classificação 2ª opção de turma"
  //                                 position={classItem.position}
  //                                 status={classItem.status}
  //                               />
  //                             );
  //                           }

  //                           return null;
  //                         })}
  //                       </>
  //                     )}
  //                   </VStack>

  //                   <Box mt={4}>
  //                     <TextXS fontWeight="bold">Pontuação</TextXS>
  //                     <Box>
  //                       {getResult?.data?.final?.nf && (
  //                         <TextXS>
  //                           <strong>Nota final:</strong> {getResult?.data?.final?.nf} pontos
  //                         </TextXS>
  //                       )}
  //                       {getResult?.data?.final?.npo && (
  //                         <TextXS>
  //                           <strong>Nota prova objetiva:</strong> {getResult?.data?.final?.npo} pontos
  //                         </TextXS>
  //                       )}
  //                       {getResult?.data?.final?.npt && (
  //                         <TextXS>
  //                           <strong>Nota prova títulos:</strong> {getResult?.data?.final?.npt} pontos
  //                         </TextXS>
  //                       )}
  //                       {getResult?.data?.final?.npd && (
  //                         <TextXS>
  //                           <strong>Nota prova Discursiva:</strong> {getResult?.data?.final?.npd} pontos
  //                         </TextXS>
  //                       )}
  //                       {getResult?.data?.final?.npr && (
  //                         <TextXS>
  //                           <strong>Nota Redação:</strong> {getResult?.data?.final?.npr} pontos
  //                         </TextXS>
  //                       )}
  //                     </Box>

  //                     {isComplexData(getResult?.data?.final?.data) && (
  //                       <Box mt={2}>
  //                         <TextXS fontWeight="bold">Pontuação por disciplina:</TextXS>
  //                         {getResult.data.final.data.score
  //                           .sort((a, b) => {
  //                             if (a.label.toLowerCase().includes('prova')) return -1;
  //                             if (b.label.toLowerCase().includes('prova')) return 1;
  //                             return 0;
  //                           })
  //                           .map((scoreItem, i) => (
  //                             <ScoreItemComponent key={i} scoreItem={scoreItem} />
  //                             // <Box ml={!scoreItem.label.toLowerCase().includes('prova') ? 4 : 0} key={i}>
  //                             //   <TextXS>
  //                             //     <strong>
  //                             //       {scoreItem.label.toLowerCase().includes('prova') ? 'Nota final' : scoreItem.label}:
  //                             //     </strong>{' '}
  //                             //     {scoreItem.points} pontos
  //                             //     {(scoreItem.qnt_correct_answers || 0) > 0 &&
  //                             //       ` (${scoreItem.qnt_correct_answers} acertos)`}
  //                             //   </TextXS>
  //                             // </Box>
  //                           ))}
  //                       </Box>
  //                     )}

  //                     {Array.isArray(getResult?.data?.final?.data) && (
  //                       <Box mt={2}>
  //                         <TextXS fontWeight="bold">Detalhamento:</TextXS>
  //                         {getResult.data.final.data.map((dataItem, i) => (
  //                           <Box key={i} ml={4}>
  //                             <TextXS>
  //                               <strong>{dataItem.label}:</strong> {dataItem.points} pontos
  //                             </TextXS>
  //                           </Box>
  //                         ))}
  //                       </Box>
  //                     )}
  //                   </Box>
  //                 </>
  //               </Box>
  //             </Stack>
  //           </>
  //         )}

  //         <Divider pt={3} mb={3} borderColor="secondaryColor" />
  //         <Stack>
  //           <TextM textAlign="center" fontWeight="bold" textTransform="uppercase">
  //             RESULTADOS POR ETAPAS
  //           </TextM>
  //           <TextXS fontWeight="bold">Selecione o(s) resultado(s) para visualização:</TextXS>
  //           <CheckboxGroup value={typeResult} onChange={(values) => setTypeResult(values as string[])}>
  //             <Flex gap={[5, 5, 5, 5, 5]} flexDir={['row', 'row', 'row', 'row', 'row']}>
  //               <Checkbox value="Preliminar">Preliminar</Checkbox>
  //               <Checkbox value="Final">Final</Checkbox>
  //             </Flex>
  //           </CheckboxGroup>

  //           <Stack mb={5} p={0} mt={5}>
  //             <SimpleGrid spacing={4} columns={{ base: 1, md: 2 }}>
  //               {getResult?.data?.steps &&
  //               getResult?.data?.steps?.filter((i) => typeResult.includes(i?.type)).length === 0 ? (
  //                 <>
  //                   <TextXS>Sem resultados para exibição</TextXS>
  //                 </>
  //               ) : (
  //                 getResult?.data?.steps
  //                   ?.filter((i) => typeResult.includes(i?.type))
  //                   .map((item, index) => {
  //                     const hasComplexData = isComplexData(item.data);

  //                     return (
  //                       <Box key={index} borderWidth="1px" borderRadius="xl" p={5} shadow="md">
  //                         <Heading fontSize="xl" mb={2}>
  //                           {item.name}
  //                         </Heading>

  //                         {hasComplexData ? (
  //                           <>
  //                             <VStack align="start" spacing={1}>
  //                               <TextXS>
  //                                 <strong>Tipo de resultado:</strong> {item.type}
  //                               </TextXS>

  //                               {isComplexData(item.data) &&
  //                                 item.data.classification.map((classItem, idx) => {
  //                                   const label = classItem.label.toLowerCase();

  //                                   if (label.includes('ampla concorrência')) {
  //                                     return (
  //                                       <ResultStepCard
  //                                         key={idx}
  //                                         title="Classificação ampla concorrência"
  //                                         position={classItem.position}
  //                                         status={classItem.status}
  //                                       />
  //                                     );
  //                                   }

  //                                   if (
  //                                     label.includes('geral') &&
  //                                     (getRegistration?.data?.type_of_competition?.length ?? 0) > 1
  //                                   ) {
  //                                     return (
  //                                       <ResultStepCard
  //                                         key={idx}
  //                                         title="Classificação geral"
  //                                         position={classItem.position}
  //                                         status={classItem.status}
  //                                       />
  //                                     );
  //                                   }

  //                                   if (label.includes('pcd')) {
  //                                     return (
  //                                       <ResultStepCard
  //                                         key={idx}
  //                                         title="Classificação PCD"
  //                                         position={classItem.position}
  //                                         status={classItem.status}
  //                                       />
  //                                     );
  //                                   }

  //                                   if (label.includes('preto') || label.includes('pardo')) {
  //                                     return (
  //                                       <ResultStepCard
  //                                         key={idx}
  //                                         title="Classificação pretos e pardos"
  //                                         position={classItem.position}
  //                                         status={classItem.status}
  //                                       />
  //                                     );
  //                                   }

  //                                   if (label.includes('segunda') || label.includes('2')) {
  //                                     return (
  //                                       <ResultStepCard
  //                                         key={idx}
  //                                         title="Classificação 2ª opção de turma"
  //                                         position={classItem.position}
  //                                         status={classItem.status}
  //                                       />
  //                                     );
  //                                   }

  //                                   return null;
  //                                 })}
  //                             </VStack>

  //                             {isComplexData(item.data) && (
  //                               <Box mt={1}>
  //                                 <TextXS fontWeight="bold">Pontuação por disciplina:</TextXS>
  //                                 {item.data.score
  //                                   .sort((a, b) => {
  //                                     if (a.label.toLowerCase().includes('prova')) return -1;
  //                                     if (b.label.toLowerCase().includes('prova')) return 1;
  //                                     return 0;
  //                                   })
  //                                   .map((scoreItem, i) => (
  //                                     <ScoreItemComponent key={i} scoreItem={scoreItem} />
  //                                     // <Box ml={!scoreItem.label.toLowerCase().includes('prova') ? 4 : 0} key={i}>
  //                                     //   <TextXS>
  //                                     //     <strong>
  //                                     //       {scoreItem.label.toLowerCase().includes('prova')
  //                                     //         ? 'Nota final'
  //                                     //         : scoreItem.label}
  //                                     //       :
  //                                     //     </strong>{' '}
  //                                     //     {scoreItem.points} pontos
  //                                     //     {(scoreItem.qnt_correct_answers || 0) > 0 &&
  //                                     //       ` (${scoreItem.qnt_correct_answers} acertos)`}
  //                                     //     {!scoreItem.label.toLowerCase().includes('prova') && (
  //                                     //       <TextXXS cursor={'pointer'} ml={1} color={'blue'} as="span">
  //                                     //         Ver mais
  //                                     //       </TextXXS>
  //                                     //     )}
  //                                     //   </TextXS>
  //                                     // </Box>
  //                                   ))}
  //                               </Box>
  //                             )}
  //                           </>
  //                         ) : (
  //                           <>
  //                             <TextXS>
  //                               <strong>Tipo do resultado:</strong> {item.type}
  //                             </TextXS>

  //                             <Box mt={2}>
  //                               <TextXS fontWeight="bold">Pontuação:</TextXS>
  //                               {Array.isArray(item.data) &&
  //                                 item.data.map((dataItem, i) => {
  //                                   // Formato 1: Com questões e critérios
  //                                   if (dataItem.question && Array.isArray(dataItem.criterias)) {
  //                                     const questionLabel = dataItem.question.replace(/^q(\d+)$/i, 'Questão $1');
  //                                     return (
  //                                       <Box key={i} ml={4} mb={3}>
  //                                         <TextXS fontWeight="semibold" mb={1}>
  //                                           {questionLabel}:
  //                                         </TextXS>
  //                                         {dataItem.criterias.map((criteria, j) => (
  //                                           <Box key={j} ml={4}>
  //                                             <TextXS>
  //                                               <strong>{criteria.label}:</strong>{' '}
  //                                               {criteria.points.toString().replace('.', ',')} pontos
  //                                             </TextXS>
  //                                           </Box>
  //                                         ))}
  //                                       </Box>
  //                                     );
  //                                   }

  //                                   // Formato 2: Simples com label e points (formato original)
  //                                   else if (dataItem.label && typeof dataItem.points !== 'undefined') {
  //                                     return (
  //                                       <Box key={i} ml={4}>
  //                                         <TextXS>
  //                                           <strong>
  //                                             {dataItem?.label?.toLowerCase()?.includes('prova')
  //                                               ? 'Nota final'
  //                                               : dataItem.label}
  //                                             :
  //                                           </strong>{' '}
  //                                           {dataItem.points} pontos
  //                                         </TextXS>
  //                                       </Box>
  //                                     );
  //                                   }

  //                                   return null;
  //                                 })}
  //                             </Box>
  //                           </>
  //                         )}
  //                       </Box>
  //                     );
  //                   })
  //               )}
  //             </SimpleGrid>
  //           </Stack>
  //         </Stack>
  //         <Divider pt={3} mb={3} borderColor="secondaryColor" />
  //       </Stack>
  //     )}
  //   </MainCard>
  // );
};

export default SecondResult;
